import classNames from 'classnames';
import React from 'react';
import ImageNode from './ImageNode';
import styles from './CarouselImage.module.scss';
import type { Dimensions } from './CarouselSlider';

interface CarouselImageProps {
  src: string;
  alt: string;
  contain?: boolean;
  uploading?: boolean;
  onMeasure: ({ width, height }: Dimensions) => void;
}

const CarouselImage = ({
  src,
  alt,
  contain,
  uploading = false,
  onMeasure,
}: CarouselImageProps) => {
  return (
    <div className={styles.container}>
      <ImageNode
        src={src}
        alt={alt}
        uploading={uploading}
        onLoad={(e) => {
          const target = e.target as HTMLImageElement;
          onMeasure({
            width: target.naturalWidth,
            height: target.naturalHeight,
          });
        }}
        className={classNames(styles.image, {
          [styles.shouldContain]: contain,
        })}
        containerClassName={styles.imageContainer}
      />
    </div>
  );
};

export default CarouselImage;
